export function objectAssign(...objs){
  return Object.assign(...objs);
}
export function objectKeys(obj){
  return Object.keys(obj);
}
export function objectDefineProperty(obj,prop,desciptor){
  return Object.defineProperty(obj,prop,desciptor);
}
export function objectGetOwnPropertyDescriptor(obj,prop){
  return Object.getOwnPropertyDescriptor(obj,prop);
}
export default {
  objectAssign,
  objectKeys,
  objectDefineProperty,
  objectGetOwnPropertyDescriptor
}



// WEBPACK FOOTER //
// ./src/component/common/es.js